module.exports = __webpack_public_path__ + "media/sfx_chat_3.c014280a.mp3";